import React from 'react';
import { storiesOf } from '@kadira/storybook';

import ErrorMessages from 'modules/form/components/ErrorMessages';

storiesOf('Form', module)
  .add('ErrorMessages - blank', () => <ErrorMessages />)
  .add('ErrorMessages - single error message', () => (
    <ErrorMessages
      fields={{
        name: { error: 'name is empty' },
      }}
    />
  ))
  .add('ErrorMessages - double error messages', () => (
    <ErrorMessages
      fields={{
        name: { error: 'name is empty' },
        displayname: { error: 'displayname is required' },
      }}
    />
  ))
  .add('ErrorMessages - custom header', () => (
    <ErrorMessages
      header="Please handle the following error before continue"
      fields={{
        name: { error: 'name is empty' },
        displayname: { error: 'displayname is required' },
      }}
    />
  ));
